"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var utils = _interopRequireWildcard(require("../../shared"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
Generic component for Tooltip Content, to be used in the context of Tooltip Content
Accepts `position` (which side of the Triggershould the content be place) and
`size` (dictates the size of the actual Content box, if any)
*/
function Content(_ref) {
  var Component = _ref.componentEl,
      className = _ref.className,
      children = _ref.children,
      position = _ref.position,
      size = _ref.size,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["componentEl", "className", "children", "position", "size"]);

  var cssClasses = ['st_tooltip_content', "st_tooltip_content--" + position, "st_tooltip_content--" + size];
  cssClasses = utils.classNames.addClassNames(className, cssClasses);
  return /*#__PURE__*/_react["default"].createElement(Component, _extends({
    className: cssClasses.join(' ')
  }, otherProps), children);
}

Content.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: utils.componentEl.props,

  /** extra CSS classes, if any */
  className: utils.classNames.classNameProps,

  /** dictates the position of the tool tip content */
  position: _propTypes["default"].oneOf(['top', 'right', 'bottom', 'left']),

  /** dictates the size of the tool tip content if any  */
  size: _propTypes["default"].oneOf(['none', 'md', 'mlg', 'lg', 'xl'])
};
Content.defaultProps = {
  componentEl: 'div',
  className: null,
  position: 'top',
  size: 'none'
};
var _default = Content;
exports["default"] = _default;